export default __webpack_public_path__ + "static/media/img-13.d34266a5.jpg";